import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { formatDocumentTitle, getPageSeo } from '../config/pageSeo';
import {
  DEFAULT_DESCRIPTION,
  DEFAULT_OG_IMAGE_PATH,
  SITE_NAME,
  absoluteUrl,
} from '../config/site';
import { applyPageHead } from '../utils/documentHead';
import { buildPageJsonLd } from '../utils/pageJsonLd';

export function usePageSeo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const pageSeo = getPageSeo(pathname);
    const pageTitle = pageSeo?.title ?? SITE_NAME;
    const description = pageSeo?.description ?? DEFAULT_DESCRIPTION;
    const breadcrumbLabel = pageSeo?.breadcrumb ?? pageTitle;
    const documentTitle = formatDocumentTitle(pageTitle);
    const canonicalUrl = absoluteUrl(pathname === '' ? '/' : pathname);

    applyPageHead({
      title: documentTitle,
      description,
      canonicalUrl,
      ogImageUrl: absoluteUrl(DEFAULT_OG_IMAGE_PATH),
      siteName: SITE_NAME,
      jsonLd: buildPageJsonLd(pathname || '/', breadcrumbLabel),
    });
  }, [pathname]);
}
